import { StyleSheet, Platform, Dimensions } from 'react-native';
const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    backgroundColor: '#00000077',
    outline: 'none',
    outlineWidth: 0,
    position: 'absolute',
    bottom: 0,
    marginBottom:30
    // height: Platform.OS === 'web' ?
    //   Dimensions.get('window').height -
    //   (Dimensions.get('window').width > 767 ? 84 : 64) : Dimensions.get('window').height ,
  },
  mask: {
    flex: 1,
    backgroundColor: 'transparent',
    outline: 'none',
    outlineWidth: 0,
  },
  container: {
    backgroundColor: '#fff',
    width:
      Platform.OS === 'web' && Dimensions.get('window').width > 767
        ? 508
        : Dimensions.get('window').width,
    overflow: 'hidden',
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
  },
  draggableContainer: {
    width: '100%',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  draggableIcon: {
    width: 100,
    height: 5,
    borderRadius: 5,
    margin: 10,
    backgroundColor: '#ccc',
    marginVertical: 10,
  },
});

export default styles;
